// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module__card___HgP+s"};